module.exports = __webpack_public_path__ + "static/media/do2.68660cb4.png";